"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _context = require("../../context");

var _Left = _interopRequireDefault(require("./Left"));

var _Center = _interopRequireDefault(require("./Center"));

var _Right = _interopRequireDefault(require("./Right"));

require("./style.sass");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Header = function Header(props) {
  var pathname = props.pathname;
  return /*#__PURE__*/_react["default"].createElement(_context.MainContext.Consumer, null, function (data) {
    return /*#__PURE__*/_react["default"].createElement("header", {
      className: "wizrd-site-header ".concat(pathname !== '/' ? '' : '')
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "wizrd-main-header"
    }, props.children));
  });
};

Header.Left = _Left["default"];
Header.Center = _Center["default"];
Header.Right = _Right["default"];
var _default = Header;
exports["default"] = _default;